import {JsonProperty} from 'json-typescript-mapper';

export class Log {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('source')
  public source?: string;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty('content')
  public content?: string;

  @JsonProperty('merchantNumber')
  public merchantNumber?: string;

  @JsonProperty('recipientMerchantNumber')
  public recipientMerchantNumber?: string;

  @JsonProperty('marketdayNumber')
  public marketdayNumber?: string;

  @JsonProperty('marketdayKeyword')
  public marketdayKeyword?: string;

  @JsonProperty('recipient')
  public recipient?: string;

  constructor() {
    this.id = void 0;
    this.source = void 0;
    this.created = void 0;
    this.content = void 0;
    this.merchantNumber = void 0;
    this.recipientMerchantNumber = void 0;
    this.marketdayNumber = void 0;
    this.marketdayKeyword = void 0;
    this.recipient = void 0;
  }
}

export class SmsLog extends Log {
  message: string;
  httpResponseBody: SmsLogHttpResponseBody;

  constructor(log: Log) {
    super();
    try { this.id = log.id; } catch (e) { logError(e); }
    try { this.source = log.source; } catch (e) { logError(e); }
    try { this.created = log.created; } catch (e) { logError(e); }
    try { this.content = log.content; } catch (e) { logError(e); }
    try { this.merchantNumber = log.merchantNumber; } catch (e) { logError(e); }
    try { this.recipient = log.content.replace(/[\r\n]+/g, '')
      .split('Recipient:')[1].split('Content:')[0].trim(); } catch (e) { logError(e); }
    try { this.message = log.content.replace(/[\r\n]+/g, '')
      .split('Content:')[1].split('HTTP Response Body:')[0].trim(); } catch (e) { logError(e); }
    let httpData = '';
    try { httpData = log.content.replace(/[\r\n]+/g, '')
      .split('HTTP Response Body:')[1]; } catch (e) { logError(e); }
    this.httpResponseBody = new SmsLogHttpResponseBody(httpData, this.recipient === 'Keine Nummer');
  }
}

export class SmsLogHttpResponseBody {
  err: string;
  number: string;
  msgid: string;
  price: string;
  remainingBalance: string;
  creditLimit: string;
  responseMessage: string;

  constructor(httpData, noNumberStatus: boolean = false) {
    try { this.err = httpData.split('err:')[1].split('Nummer:')[0].trim(); } catch (e) { logError(e); }
    try { this.number = httpData.split('Nummer:')[1].split('MSGID:')[0].trim(); } catch (e) { logError(e); }
    try { this.msgid = httpData.split('MSGID:')[1].split('Preis:')[0].trim(); } catch (e) { logError(e); }
    try { this.price = httpData.split('Preis:')[1].split('Restguthaben:')[0].trim(); } catch (e) { logError(e); }
    try { this.remainingBalance = httpData.split('Restguthaben:')[1].split('Guthabenlimit:')[0].trim(); } catch (e) { logError(e); }
    try { this.creditLimit = httpData.split('Guthabenlimit:')[1].split('Response Message:')[0].trim(); } catch (e) { logError(e); }
    try {
      this.responseMessage = (noNumberStatus) ? 'Keine Nummer' : httpData.split('Response Message:')[1].trim();
    } catch (e) { logError(e); }
  }
}

export enum SmsStatus {
  None = <any>'None',
  Pending = <any>'Pending',
  Success = <any>'Success',
  Error = <any>'Error'
}

export function logError(e) {
  // console.log('e', e);
}

export class MailLog extends Log {
  sender: string;
  subject: string;
  message: string;
  attachements: string;

  constructor(log: Log) {
    super();
    try { this.id = log.id; } catch (e) { logError(e); }
    try { this.source = log.source; } catch (e) { logError(e); }
    try { this.created = log.created; } catch (e) { logError(e); }
    try { this.content = log.content; } catch (e) { logError(e); }
    try { this.merchantNumber = log.merchantNumber; } catch (e) { logError(e); }
    try { this.recipientMerchantNumber = log.recipientMerchantNumber; } catch (e) { logError(e); }
    try { this.marketdayNumber = log.marketdayNumber; } catch (e) { logError(e); }
    try { this.marketdayKeyword = log.marketdayKeyword; } catch (e) { logError(e); }
    try { this.recipient = log.recipient; } catch (e) { logError(e); }
    try { this.sender = log.content.replace(/[\r\n]+/g, '')
      .split('Absender:')[1].split('Betreff:')[0]
      .replace('()', '').trim(); } catch (e) { logError(e); }
    try { this.subject = log.content.replace(/[\r\n]+/g, '')
      .split('Betreff:')[1].split('Nachricht:')[0].trim(); } catch (e) { logError(e); }
    try { this.message = log.content
      // .replace(/[\r\n]+/g, '<br />')
      .split('Nachricht:')[1].split('Bilder:')[0].trim(); } catch (e) { logError(e); }
    try { this.attachements = log.content
      // .replace(/[\r\n]+/g, '')
      .split('Bilder:')[1].trim(); } catch (e) { logError(e); }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/log.model.ts